import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vitrina from 'vitrina-template-lib'
window.gotoback = false;

Vue.config.productionTip = false;

window.teaserImgs = {};

Vue.prototype.StatisPath = "/static/dzfancy-06-without-dmp2.mobile/";
Vue.prototype.Config = window.config;

Vitrina.init({
  config    : window.config,
  host      : location.origin,
  language  : window.config.language,
  timeoutLoadDmp:700,  
  isVideo:true,  
  isDmp:false,  
  isTeaserViewFixAjax:true, //отправлять ajax для логирования просмотров тизеров
  query : {
    language  : window.config.language,
  }
});

Vue.prototype.Helper = Vitrina;
Vue.prototype.isTable = function ()
{
    return window.innerWidth >= 768;
};
console.log(window.config);


router.beforeEach((to, from, next) => {
    Vitrina.routerBeforeEach(to, from, next);
});

router.afterEach((to, from) => {
    Vitrina.routerAfterEach(to, from);
});

window.vueApp = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}
).$mount('#app');